import {createContext} from 'react'

export const DonationLevelContext = createContext(0);